import {
  getTextFieldUtilityClass,
  textFieldClasses as muiTextFieldClasses,
  TextFieldProps as MuiTextFieldProps,
} from '@mui/material';
import { InputLabelProps } from '../inputLabel';
import { FormControlOwnProps } from '../form';

declare module '@mui/material/TextField' {
  interface TextFieldPropsSizeOverrides {
    large: true;
  }
}

export interface TextFieldProps extends Omit<MuiTextFieldProps, 'variant' | 'color' | 'InputLabelProps'>, FormControlOwnProps {
  readOnly?: boolean;
  InputLabelProps?: Partial<InputLabelProps>;
}

export const textFieldClasses = {
  ...muiTextFieldClasses,
  readOnly: getTextFieldUtilityClass('readOnly'),
};

export {};
